var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{class:[_vm.marginBottom],attrs:{"type":"primary","id":"btn"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t("common.backtrack")))])}
var staticRenderFns = []

export { render, staticRenderFns }